import { SearchOutlined } from '@ant-design/icons'
import { Button, Col, Form, Row, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import SelectMultiTypesFertilizers from '../../../../components/selects/SelectMultiTypesFertilizers'
import SelectCompanyWarehouses from '../../../../components/selects/SelectCompanyWarehouses'
import React, { useState } from 'react'
import SelectCompany from '../../../../components/selects/SelectCompany'

interface IProps {
	formField: any
	form: any
	onReset: () => void
	onSearch: () => void
}

export const FilterStock = (props: IProps) => {
	const { t } = useTranslation()
	const [selectedYear, setSelectedYear] = useState<string[]>([])

	const years = Array.from({ length: 20 }, (_, i) => (2025 - i).toString())

	return (
		<Form form={props.form} layout='vertical'>
			<Row gutter={16}>
				<Col span={4}>
					<Form.Item
						label={t('chemicalization.stock.company_name')}
						name={props.formField.companyId}
					>
						<SelectCompany />
					</Form.Item>
				</Col>
				<Col span={4}>
					<Form.Item
						label={t('chemicalization.stock.warehouse_name')}
						name={props.formField.warehouseId}
					>
						<SelectCompanyWarehouses />
					</Form.Item>
				</Col>
				<Col span={4}>
					<Form.Item label={t('titles.types_of_fertilizers')} name={props.formField.fertilizerIds}>
						<SelectMultiTypesFertilizers />
					</Form.Item>
				</Col>
				<Col span={4}>
					<Form.Item
						label={t('chemicalization.stock.reporting_year')}
						name={props.formField.reportingYear}
					>
						<Select
							value={selectedYear}
							onChange={setSelectedYear}
							placeholder={t('reports.select_years')}
						>
							{years.map(year => (
								<Select.Option key={year} value={year}>
									{year}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Col span={6}>
					<div style={{ marginTop: 30 }}>
						<Button
							type='primary'
							shape='default'
							size='middle'
							icon={<SearchOutlined />}
							onClick={props.onSearch}
						>
							{t('general.search')}
						</Button>
						<Button size='small' type='link' onClick={props.onReset} style={{ color: 'orange' }}>
							{t('general.reset')}
						</Button>
					</div>
				</Col>
			</Row>
		</Form>
	)
}
